import { DATE_FORMAT_TYPE } from "@shared/interfaces";
import { getFormattedDate } from "@shared/utils";
import React, { FC, useMemo } from "react";
import { RangeSlider } from "rsuite";

import "./index.scss";

type DateType = Date | null | undefined;

export interface PatientDateRangeSliderProps {
  startDate: DateType;
  endDate: DateType;
  disabled?: boolean;
  value: [DateType, DateType];
  onChange?: (value: [DateType, DateType]) => void;
}

const renderTooltip = (value?: number) => {
  return value && new Date(value).toLocaleString();
};

const PatientDateRangeSlider: FC<PatientDateRangeSliderProps> = (props) => {
  const { startDate, endDate, disabled, value } = props;

  const [startValue, endValue] = value;

  const disabledSlider = useMemo(() => {
    return disabled || !startDate || !endDate;
  }, [startDate, endDate, disabled]);

  const startDateLabel = useMemo(() => {
    if (!startDate) return "";

    return getFormattedDate(startDate, DATE_FORMAT_TYPE.SHORT);
  }, [startDate]);

  const endDateLabel = useMemo(() => {
    if (!endDate) return "";

    return getFormattedDate(endDate, DATE_FORMAT_TYPE.SHORT);
  }, [endDate]);

  return (
    <div className="date-range-slider-container">
      <div className="date-range-slider-label">
        <span>{startDateLabel}</span>
        <span>{endDateLabel}</span>
      </div>
      <RangeSlider
        barClassName="date-range-slider-bar"
        handleClassName="date-range-slider-handle"
        disabled={disabledSlider}
        step={60 * 1000}
        value={[startValue?.getTime() || 0, endValue?.getTime() || 0]}
        min={startDate?.getTime()}
        max={endDate?.getTime()}
        renderTooltip={renderTooltip}
      />
    </div>
  );
};

export default PatientDateRangeSlider;
